import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-hgs-inspection-wirestatus',
  imports: [TranslocoPipe],
  template: `
    <label class="flex items-center gap-2 text-xs md:text-sm">
      <input type="text" class="w-16 border border-slate-300 px-2 py-1" />
      <span>{{ 'documents.hgs.inspection.tires.mm' | transloco }}</span>
    </label>
    <label class="mt-2 flex items-center gap-2 text-xs md:text-sm">
      <input type="text" class="w-16 border border-slate-300 px-2 py-1" />
      <span>{{ 'documents.hgs.inspection.tires.bar' | transloco }}</span>
    </label>
  `,
  host: { class: 'block' },
  standalone: true,
})
export class HgsInspectionWireStatusComponent {}
